import React from 'react';
import { MessageCircle, ShieldCheck } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useLanguage } from '@/contexts/LanguageContext';
import { trackContactClick } from '@/lib/trackContactClick';

const WhatsAppButton: React.FC = () => {
  const { t } = useLanguage();
  const phoneNumber = '34669568722';
  const message = encodeURIComponent('Hola, me gustaría solicitar información sobre vuestros servicios.');
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${message}`;

  const { language } = useLanguage();
  return (
    <>
      <Link
        to="/inspeccion-de-rocodromos"
        className="md:hidden fixed bottom-20 left-6 z-50 flex items-center gap-2 bg-primary text-primary-foreground px-4 py-2.5 rounded-full shadow-lg text-sm font-semibold"
      >
        <ShieldCheck className="h-5 w-5" />
        {language === 'eu' ? 'Ikuskapena eskatu' : 'Pedir inspección'}
      </Link>
      <a
        href={whatsappUrl}
        onClick={() => trackContactClick('whatsapp')}
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-6 left-6 z-50 flex items-center gap-2 bg-[#25D366] text-white px-4 py-3 rounded-full shadow-lg hover:bg-[#20BD5A] transition-all hover:scale-105 group"
        aria-label={t('contact.whatsapp')}
      >
        <MessageCircle className="h-6 w-6" />
        <span className="hidden md:inline font-medium">WhatsApp</span>
      </a>
    </>
  );
};

export default WhatsAppButton;
